module.exports = __webpack_public_path__ + "img/big-electric-pole.098b033d.png";